module.exports = __webpack_public_path__ + "static/media/5ed79bdb72f4e5e57a748783.651492f4.png";